export default {
      id: "battery-usage",
      viewBox: "0 0 10.442 17.064",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#battery",
      toString: function () {
        return this.url;
      }
    }